module.exports = __webpack_public_path__ + "d4f6332eeb1069f95bdc80396ea31dcd.fbx";